import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { NavLink, Outlet } from "react-router-dom";

const StyledNavLink = styled(NavLink)(({ theme }) => ({
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    fontWeight: 700,
    fontSize: '1.25rem',
    // paddingBottom: '0.5rem',
    color: theme.palette.text.secondary,
    '&:hover': {
        color: theme.palette.primary.main,
    },
    '&.active': {
        color: theme.palette.primary.main,
        borderBottom: `4px solid ${theme.palette.primary.main}`,
    }
}));

const UserList = () => {

    return (
        <Box sx={{
            bgcolor: 'background.default',
            color: 'text.primary',
            // minHeight: '100vh',
            p: 2,
            px: 0,
        }}>
            <Box sx={{ display: 'flex', gap: 3, mb: 2, px: 2 }}>
                <StyledNavLink to="/users" end>
                    Users List
                </StyledNavLink>
                <StyledNavLink to="/users/analytics">
                    Analytics
                </StyledNavLink>
            </Box>

            {/* Render child routes here */}
            <Outlet />
        </Box>
    );
};

export default UserList;
